import { useState } from 'react'
import PropTypes from 'prop-types'
import { Carousel } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import CTA from 'components/CTA'
import CategoryCarousel from 'components/CategoryCarousel'
import { useCoursesByCategory } from 'libs/client/api'
import { articleCategoryPath } from 'libs/paths'
import CourseOverlayStackedTile from './CourseOverlayStackedTile'
import { trackCtaClicked } from './events'

const InstructorCarousel = ({
  controls = true,
  peek = false,
  showCount = 4,
  className = '',
  ...props
}) => {
  const { article, categories } = useStaticData()
  const [selectedCategory, setSelectedCategory] = useState(
    article.mcCategorySlug,
  )
  const { coursesByCategory, error } = useCoursesByCategory(selectedCategory)
  const { t } = useTranslation('@mc/next')

  const handleCategoryClick = (category) => {
    setSelectedCategory(category.slug)
  }

  return (
    <section className='container mc-py-10'>
      <div
        className={`${className} col-12 mc-theme-light mc-bg-gray-700 mc-p-6`}
      >
        <h2 className='mc-text--center mc-text-h4'>
          {t('article.instructorCarousel.title')}
        </h2>
        <div className='col-lg-12'>
          <CategoryCarousel
            asButton
            categories={categories}
            className='mc-p-4'
            getPathFunction={articleCategoryPath}
            onCategoryClick={handleCategoryClick}
            selectedCategory={selectedCategory}
          />
          {error && (
            <p className='mc-text--center mc-mb-2'>
              {t('common.errors.generic')}
            </p>
          )}
          {coursesByCategory && !error && (
            <>
              <div className='d-block d-md-none'>
                <Carousel
                  controls={controls}
                  peek={peek}
                  scrollCount={2}
                  showCount={2}
                  {...props}
                >
                  {coursesByCategory.map((course) => (
                    <CourseOverlayStackedTile
                      key={course.slug}
                      course={course}
                    />
                  ))}
                </Carousel>
              </div>
              <div className='d-none d-md-block'>
                <Carousel
                  controls={controls}
                  peek={peek}
                  scrollCount={showCount}
                  showCount={showCount}
                  {...props}
                >
                  {coursesByCategory.map((course) => (
                    <CourseOverlayStackedTile
                      key={course.slug}
                      course={course}
                    />
                  ))}
                </Carousel>
              </div>
            </>
          )}
        </div>
        <div className='col-lg-12 mc-text--center'>
          <CTA onClick={trackCtaClicked} />
        </div>
      </div>
    </section>
  )
}

InstructorCarousel.propTypes = {
  controls: PropTypes.bool,
  peek: PropTypes.bool,
  showCount: PropTypes.number,
  className: PropTypes.string,
}

export default InstructorCarousel
